module.exports = __webpack_public_path__ + "img/shirt-long-sleeve.8decfa6f.svg";